import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { navigate } from 'gatsby'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	Stitch,
	UserApiKeyCredential,
	RemoteMongoClient,
} from 'mongodb-stitch-browser-sdk'
import BSON from 'mongodb-stitch-bson'

const FormSchema = Yup.object().shape({
	calls: Yup.string().matches(
		/^[0-9]{1,2}$/,
		'Calls, must be a number range 0-99'
	),
	emails: Yup.string().matches(
		/^[0-9]{1,2}$/,
		'Emails, must be a number range 0-99'
	),
	texts: Yup.string().matches(
		/^[0-9]{1,2}$/,
		'Texts, must be a number range 0-99'
	),
})

function validationIcons(valid) {
	return valid ? (
		<span className="icon is-small is-right">
			<FontAwesomeIcon icon="exclamation-triangle" />
		</span>
	) : (
		<span className="icon is-small is-right">
			<FontAwesomeIcon icon="check" />
		</span>
	)
}

class BookingUnconfirmed extends Component {
	constructor(props) {
		super(props)
		this.state = {
			mongoDBStatus: '',
		}
	}

	componentDidMount() {
		if (!Stitch.hasAppClient('book-a-demo-hcaug')) {
			this.client = Stitch.initializeDefaultAppClient('book-a-demo-hcaug')
		} else {
			this.client = Stitch.defaultAppClient
		}
		this.db = this.client
			.getServiceClient(RemoteMongoClient.factory, 'mongodb-atlas')
			.db('bookings')
	}

	render() {
		const { params, formName } = this.props
		return (
			<Formik
				initialValues={{
					calls: '0',
					emails: '0',
					texts: '0',
					notes: '',
				}}
				validationSchema={FormSchema}
				onSubmit={(values, { setSubmitting, setStatus, resetForm }) => {
					const { calls, emails, texts, notes } = values
					setSubmitting(true)
					if (!/^[0-9a-fA-F]{24}$/.test(params.id)) {
						return (
							this.setState({
								mongoDBStatus: `Unique Lead ID is invalid, please check your lead email and try again`,
							}),
							setSubmitting(false),
							setStatus('failure')
						)
					}
					this.client.auth
						.loginWithCredential(
							new UserApiKeyCredential(process.env.GATSBY_MONGODB)
						)
						.then(
							res => {
								this.setState({
									mongoDBStatus: `MongoDB API - logged in as user: ${
										res.id
									}\n${res}`,
								})
								this.db
									.collection('leads')
									.updateOne(
										{ _id: BSON.ObjectId(params.id) },
										{
											$set: {
												bookingNotes: `Called ${calls} times, emailed ${emails} times, sent ${texts} texts. Notes: ${notes}`,
												bookingStatus: 'unconfirmed',
												leadStatus: 'stale',
											},
										}
									)
									.then(
										res => {
											this.setState({
												mongoDBStatus: `MongoDB API PUT is Good:\n${res}`,
											})
											this.client
												.callFunction('bookingUnconfirmed', [params.id])
												.then(res => {
													this.setState({
														mongoDBStatus: `MongoDB API CALL is Good:\n${res}`,
													})
													setSubmitting(false)
													resetForm()
													navigate(
														'/unable-to-confirm?form=booking-unconfirmed'
													)
													setStatus('success')
												})
												.catch(err => {
													this.setState({
														mongoDBStatus: `MongoDB API CALL is Bad: ${
															err.message
														}\n${err}`,
													})
													setSubmitting(false)
													setStatus('failure')
												})
										},
										err => {
											this.setState({
												mongoDBStatus: `MongoDB API CALL is Bad: ${
													err.message
												}\n${err}`,
											})
											setSubmitting(false)
											setStatus('failure')
										}
									)
									.catch(err => {
										this.setState({
											mongoDBStatus: `MongoDB API PUT is Bad: ${
												err.message
											}\n${err}`,
										})
										setSubmitting(false)
										setStatus('failure')
									})
							},
							err => {
								this.setState({
									mongoDBStatus: `MongoDB API Auth is bad: ${
										err.message
									}\n${err}`,
								})
								setSubmitting(false)
								setStatus('failure')
							}
						)
				}}
				render={({
					values,
					handleSubmit,
					isSubmitting,
					setStatus,
					status,
					handleChange,
					handleBlur,
					touched,
					errors,
				}) => (
					<form
						name={formName}
						method="post"
						data-netlify="true"
						data-netlify-honeypot="bot-field"
						onSubmit={handleSubmit}
						className="form"
					>
						<input type="hidden" name="form-name" defaultValue={formName} />
						<div className="field is-horizontal">
							<div className="field-label">
								<label className="label">Contacted</label>
							</div>
							<div className="field-body">
								<div className="field calls" aria-describedby="calls">
									<label className="label is-small" htmlFor="calls">
										Calls
									</label>
									<div className="control has-icons-left has-icons-right">
										<input
											id="calls"
											name="calls"
											type="tel"
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.calls}
											placeholder="0 Times"
											className={classNames(
												touched.calls && errors.calls && `is-danger`,
												values.calls && !errors.calls && `is-success`,
												`input`
											)}
										/>
										<span className="icon is-small is-left">
											<FontAwesomeIcon icon="phone" />
										</span>
										{touched.calls && errors.calls && validationIcons(true)}
										{values.calls && !errors.calls && validationIcons(false)}
									</div>
									{touched.calls && errors.calls && (
										<p className="help is-danger" id="calls-helper-text">
											{errors.calls}
										</p>
									)}
								</div>
								<div className="field emails" aria-describedby="emails">
									<label className="label is-small" htmlFor="emails">
										Emails
									</label>
									<div className="control has-icons-left has-icons-right">
										<input
											id="emails"
											name="emails"
											type="tel"
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.emails}
											placeholder="0 Times"
											className={classNames(
												touched.emails && errors.emails && `is-danger`,
												values.emails && !errors.emails && `is-success`,
												`input`
											)}
										/>
										<span className="icon is-small is-left">
											<FontAwesomeIcon icon="envelope" />
										</span>
										{touched.emails && errors.emails && validationIcons(true)}
										{values.emails && !errors.emails && validationIcons(false)}
									</div>
									{touched.emails && errors.emails && (
										<p className="help is-danger" id="emails-helper-text">
											{errors.emails}
										</p>
									)}
								</div>
								<div className="field texts" aria-describedby="texts">
									<label className="label is-small" htmlFor="texts">
										Texts
									</label>
									<div className="control has-icons-left has-icons-right">
										<input
											id="texts"
											name="texts"
											type="tel"
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.texts}
											placeholder="0 Times"
											className={classNames(
												touched.texts && errors.texts && `is-danger`,
												values.texts && !errors.texts && `is-success`,
												`input`
											)}
										/>
										<span className="icon is-small is-left">
											<FontAwesomeIcon icon="mobile-alt" />
										</span>
										{touched.texts && errors.texts && validationIcons(true)}
										{values.texts && !errors.texts && validationIcons(false)}
									</div>
									{touched.texts && errors.texts && (
										<p className="help is-danger" id="texts-helper-text">
											{errors.texts}
										</p>
									)}
								</div>
							</div>
						</div>
						<div className="field is-horizontal">
							<div className="field-label">
								<label className="label">Notes</label>
							</div>
							<div className="field-body">
								<div className="field is-expanded" aria-describedby="notes">
									<label className="label is-small" htmlFor="notes">
										<span className="icon is-small is-left">
											<FontAwesomeIcon icon="sticky-note" />
										</span>{' '}
										Optional notes about unconfirmability of booking
									</label>
									<div className="control has-icons-right">
										<textarea
											id="notes"
											name="notes"
											value={values.notes}
											onChange={handleChange}
											onBlur={handleBlur}
											className="textarea"
											placeholder="I couldn't get in contact with customer..."
										/>
									</div>
								</div>
							</div>
						</div>
						<p className="has-text-centered">
							<button
								type="submit"
								disabled={isSubmitting}
								className={classNames(
									isSubmitting && `is-loading`,
									`button is-warning is-medium`
								)}
							>
								Submit
							</button>
						</p>
						<div
							className={status === 'success' ? `is-active modal` : `modal`}
							id="form-success"
						>
							<div className="modal-background" onClick={() => setStatus('')}>
								<div className="before" />
								<div className="after" />
							</div>
							<div className="modal-content">
								<div className="box">
									<div className="content">
										<h1>Thanks for trying to contact the customer 👍</h1>
										<p>We will be in touch with you shortly.</p>
									</div>
								</div>
							</div>
							<button
								className="modal-close is-large"
								aria-label="close"
								onClick={() => setStatus('')}
							/>
						</div>
						<div
							className={status === 'failure' ? `is-active modal` : `modal`}
							id="form-failure"
						>
							<div className="modal-background" onClick={() => setStatus('')} />
							<div className="modal-content">
								<div className="box">
									<div className="content">
										<h1>Something went wrong 😞</h1>
										<p>
											Form is invalid, please check your details and try again.
										</p>
										<pre>{this.state.mongoDBStatus}</pre>
									</div>
								</div>
							</div>
							<button
								className="modal-close is-large"
								aria-label="close"
								onClick={() => setStatus('')}
							/>
						</div>
					</form>
				)}
			/>
		)
	}
}

BookingUnconfirmed.propTypes = {
	formName: PropTypes.string,
	params: PropTypes.object,
}

export default BookingUnconfirmed
